import type { LocationQuery } from 'vue-router';

/**
 * TODO: What is this function actually used for?
 *
 * @param query
 * @returns
 */
export function getObjectsFromQuery(query: LocationQuery): Record<string, Record<string, string>> {
    const objects = Object.create(null) as Record<string, Record<string, string>>;

    for (const key of Object.keys(query)) {
        if (!key.endsWith(']')) continue;

        const match = key.match(/^([a-zA-Z0-9_-]+)\[([a-zA-Z0-9_-]*)\]$/);
        if (!match) continue;

        const [_, objectName, objectKey] = match;
        if (!objectName || !objectKey || isUnsafeKey(objectName) || isUnsafeKey(objectKey)) continue;

        const value = query[key];
        if (typeof value !== 'string') continue;

        const object = objects[objectName] ?? (objects[objectName] = Object.create(null));
        object[objectKey] = value;
    }

    return objects;
}

const UNSAFE_KEYS = new Set(['__proto__', 'constructor', 'prototype']);

function isUnsafeKey(key: string): boolean {
    return UNSAFE_KEYS.has(key);
}
